// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"fbee931e","453":"bb2ce72b"}[chunkId] + ".chunk.js";
};